module.exports = __webpack_public_path__ + "static/media/ring-transparent.95061248.png";